// import { createAppStore } from '@nackle/arcade-core-v2';
import { createAppStore } from '@nackle/arcade-core-v2';


export const appStore = createAppStore();
